// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 1) Remove any default Ant Design border in inline mode */
.ant-menu-inline .ant-menu-submenu-title::after,
.ant-menu-inline .ant-menu-item::after {
  border-right: none !important;
}

/* 2) Uniform dark background for the entire menu */
.ant-menu-dark {
  background-color: #1F2640 !important; /* same as your Sider background */
}

/* 3) Submenu titles: same dark background, soft text color, bold text, no border radius, full width */
.ant-menu-dark .ant-menu-submenu-title {
  background-color: #1F2640 !important;
  color: #ccc !important; /* softer text color for inactive items */
  margin: 0 !important;
  border-left: none !important; /* no left border */
  font-weight: 500 !important;  /* make text bold */
  border-radius: 0 !important;  /* remove border radius */
  width: 100% !important;       /* use full width */
}

/* 4) Menu items: same dark background, soft text color, bold text */
.ant-menu-dark .ant-menu-item {
  background-color: #1F2640 !important;
  color: #ccc !important;
  margin: 0 !important;
  border-left: none !important;
  font-weight: 500 !important;
}

/* 5) Hover state: no color block, just white text */
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-submenu-title:hover {
  background-color: #1F2640 !important; /* stays uniform */
  color: #fff !important;              /* text becomes white */
}

/* 6) Active (selected) item: keep same background, white text */
.ant-menu-dark .ant-menu-item-selected,
.ant-menu-dark .ant-menu-submenu-selected {
  background-color: #1F2640 !important;
  color: #fff !important;
}

/* 7) Ensure icons in selected items also become white */
.ant-menu-dark .ant-menu-item-selected i,
.ant-menu-dark .ant-menu-submenu-selected i {
  color: #fff !important;
}

/* 8) Submenu arrow icons (when open or hovered) should also be white */
.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {
  color: #fff !important;
}

/* 9) Force submenu popups to full width, remove border radius, and keep uniform background */
.ant-menu-dark .ant-menu-sub {
  background-color: #1F2640 !important;
  border-radius: 0 !important;
  width: 100% !important;
}

/* Hide scrollbar for Chrome, Safari, and Opera */
.custom-scrollbar::-webkit-scrollbar {
    display: none !important;
  }
  
  /* Hide scrollbar for IE, Edge, and Firefox */
  .custom-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;     /* Firefox */
    padding-bottom: 20px; /* Existing bottom padding */
  }
  
  /* Add extra scroll space at the bottom using a pseudo-element */
  .custom-scrollbar::after {
    content: "";
    display: block;
    height: 50px; /* Adjust height as needed */
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/custom.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;;EAEE,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,oCAAoC,EAAE,kCAAkC;AAC1E;;AAEA,sGAAsG;AACtG;EACE,oCAAoC;EACpC,sBAAsB,EAAE,yCAAyC;EACjE,oBAAoB;EACpB,4BAA4B,EAAE,mBAAmB;EACjD,2BAA2B,GAAG,mBAAmB;EACjD,2BAA2B,GAAG,yBAAyB;EACvD,sBAAsB,QAAQ,mBAAmB;AACnD;;AAEA,oEAAoE;AACpE;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;;EAEE,oCAAoC,EAAE,kBAAkB;EACxD,sBAAsB,eAAe,uBAAuB;AAC9D;;AAEA,gEAAgE;AAChE;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;;EAEE,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;;EAEE,sBAAsB;AACxB;;AAEA,6FAA6F;AAC7F;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;IACI,wBAAwB;EAC1B;;EAEA,6CAA6C;EAC7C;IACE,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,MAAM,YAAY;IACvC,oBAAoB,EAAE,4BAA4B;EACpD;;EAEA,gEAAgE;EAChE;IACE,WAAW;IACX,cAAc;IACd,YAAY,EAAE,4BAA4B;EAC5C","sourcesContent":["/* 1) Remove any default Ant Design border in inline mode */\n.ant-menu-inline .ant-menu-submenu-title::after,\n.ant-menu-inline .ant-menu-item::after {\n  border-right: none !important;\n}\n\n/* 2) Uniform dark background for the entire menu */\n.ant-menu-dark {\n  background-color: #1F2640 !important; /* same as your Sider background */\n}\n\n/* 3) Submenu titles: same dark background, soft text color, bold text, no border radius, full width */\n.ant-menu-dark .ant-menu-submenu-title {\n  background-color: #1F2640 !important;\n  color: #ccc !important; /* softer text color for inactive items */\n  margin: 0 !important;\n  border-left: none !important; /* no left border */\n  font-weight: 500 !important;  /* make text bold */\n  border-radius: 0 !important;  /* remove border radius */\n  width: 100% !important;       /* use full width */\n}\n\n/* 4) Menu items: same dark background, soft text color, bold text */\n.ant-menu-dark .ant-menu-item {\n  background-color: #1F2640 !important;\n  color: #ccc !important;\n  margin: 0 !important;\n  border-left: none !important;\n  font-weight: 500 !important;\n}\n\n/* 5) Hover state: no color block, just white text */\n.ant-menu-dark .ant-menu-item:hover,\n.ant-menu-dark .ant-menu-submenu-title:hover {\n  background-color: #1F2640 !important; /* stays uniform */\n  color: #fff !important;              /* text becomes white */\n}\n\n/* 6) Active (selected) item: keep same background, white text */\n.ant-menu-dark .ant-menu-item-selected,\n.ant-menu-dark .ant-menu-submenu-selected {\n  background-color: #1F2640 !important;\n  color: #fff !important;\n}\n\n/* 7) Ensure icons in selected items also become white */\n.ant-menu-dark .ant-menu-item-selected i,\n.ant-menu-dark .ant-menu-submenu-selected i {\n  color: #fff !important;\n}\n\n/* 8) Submenu arrow icons (when open or hovered) should also be white */\n.ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-arrow,\n.ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-submenu-arrow {\n  color: #fff !important;\n}\n\n/* 9) Force submenu popups to full width, remove border radius, and keep uniform background */\n.ant-menu-dark .ant-menu-sub {\n  background-color: #1F2640 !important;\n  border-radius: 0 !important;\n  width: 100% !important;\n}\n\n/* Hide scrollbar for Chrome, Safari, and Opera */\n.custom-scrollbar::-webkit-scrollbar {\n    display: none !important;\n  }\n  \n  /* Hide scrollbar for IE, Edge, and Firefox */\n  .custom-scrollbar {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;     /* Firefox */\n    padding-bottom: 20px; /* Existing bottom padding */\n  }\n  \n  /* Add extra scroll space at the bottom using a pseudo-element */\n  .custom-scrollbar::after {\n    content: \"\";\n    display: block;\n    height: 50px; /* Adjust height as needed */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
